export enum DialogActions {
    ARCHIVE = 'archive', // TODO: Check
    UNARCHIVE = 'unarchive',
    ERROR = 'error',
 }
 